var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.notificationHidden)?_c('div',{class:this.color},[_c('button',{staticClass:"delete",on:{"click":function($event){_vm.notificationHidden = true}}}),_vm._v(" "+_vm._s(this.notificationData.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }